/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#Account
 */
var Account = 'http://www.w3.org/ns/solid/terms#Account';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#Inbox
 */
var Inbox = 'http://www.w3.org/ns/solid/terms#Inbox';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#InsertDeletePatch
 */
var InsertDeletePatch = 'http://www.w3.org/ns/solid/terms#InsertDeletePatch';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#ListedDocument
 */
var ListedDocument = 'http://www.w3.org/ns/solid/terms#ListedDocument';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#Notification
 */
var Notification = 'http://www.w3.org/ns/solid/terms#Notification';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#Patch
 */
var Patch = 'http://www.w3.org/ns/solid/terms#Patch';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#Timeline
 */
var Timeline = 'http://www.w3.org/ns/solid/terms#Timeline';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#TypeIndex
 */
var TypeIndex = 'http://www.w3.org/ns/solid/terms#TypeIndex';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#TypeRegistration
 */
var TypeRegistration = 'http://www.w3.org/ns/solid/terms#TypeRegistration';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#UnlistedDocument
 */
var UnlistedDocument = 'http://www.w3.org/ns/solid/terms#UnlistedDocument';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#account
 */
var account = 'http://www.w3.org/ns/solid/terms#account';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#deletes
 */
var deletes = 'http://www.w3.org/ns/solid/terms#deletes';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#forClass
 */
var forClass = 'http://www.w3.org/ns/solid/terms#forClass';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#inbox
 */
var inbox = 'http://www.w3.org/ns/solid/terms#inbox';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#inserts
 */
var inserts = 'http://www.w3.org/ns/solid/terms#inserts';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#instance
 */
var instance = 'http://www.w3.org/ns/solid/terms#instance';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#instanceContainer
 */
var instanceContainer = 'http://www.w3.org/ns/solid/terms#instanceContainer';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#loginEndpoint
 */
var loginEndpoint = 'http://www.w3.org/ns/solid/terms#loginEndpoint';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#logoutEndpoint
 */
var logoutEndpoint = 'http://www.w3.org/ns/solid/terms#logoutEndpoint';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#notification
 */
var notification = 'http://www.w3.org/ns/solid/terms#notification';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#oidcIssuer
 */
var oidcIssuer = 'http://www.w3.org/ns/solid/terms#oidcIssuer';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#owner
 */
var owner = 'http://www.w3.org/ns/solid/terms#owner';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#patches
 */
var patches = 'http://www.w3.org/ns/solid/terms#patches';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#privateTypeIndex
 */
var privateTypeIndex = 'http://www.w3.org/ns/solid/terms#privateTypeIndex';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#publicTypeIndex
 */
var publicTypeIndex = 'http://www.w3.org/ns/solid/terms#publicTypeIndex';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#read
 */
var read = 'http://www.w3.org/ns/solid/terms#read';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#storageQuota
 */
var storageQuota = 'http://www.w3.org/ns/solid/terms#storageQuota';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#storageUsage
 */
var storageUsage = 'http://www.w3.org/ns/solid/terms#storageUsage';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#typeIndex
 */
var typeIndex = 'http://www.w3.org/ns/solid/terms#typeIndex';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#timeline
 */
var timeline = 'http://www.w3.org/ns/solid/terms#timeline';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/solid/terms#where
 */
var where = 'http://www.w3.org/ns/solid/terms#where';

var solidImport = /*#__PURE__*/Object.freeze({
	Account: Account,
	Inbox: Inbox,
	InsertDeletePatch: InsertDeletePatch,
	ListedDocument: ListedDocument,
	Notification: Notification,
	Patch: Patch,
	Timeline: Timeline,
	TypeIndex: TypeIndex,
	TypeRegistration: TypeRegistration,
	UnlistedDocument: UnlistedDocument,
	account: account,
	deletes: deletes,
	forClass: forClass,
	inbox: inbox,
	inserts: inserts,
	instance: instance,
	instanceContainer: instanceContainer,
	loginEndpoint: loginEndpoint,
	logoutEndpoint: logoutEndpoint,
	notification: notification,
	oidcIssuer: oidcIssuer,
	owner: owner,
	patches: patches,
	privateTypeIndex: privateTypeIndex,
	publicTypeIndex: publicTypeIndex,
	read: read,
	storageQuota: storageQuota,
	storageUsage: storageUsage,
	typeIndex: typeIndex,
	timeline: timeline,
	where: where
});

export { Account as A, Inbox as I, ListedDocument as L, Notification as N, Patch as P, Timeline as T, UnlistedDocument as U, InsertDeletePatch as a, TypeIndex as b, TypeRegistration as c, account as d, deletes as e, forClass as f, inserts as g, instance as h, inbox as i, instanceContainer as j, logoutEndpoint as k, loginEndpoint as l, owner as m, notification as n, oidcIssuer as o, patches as p, privateTypeIndex as q, publicTypeIndex as r, read as s, storageQuota as t, storageUsage as u, typeIndex as v, timeline as w, where as x, solidImport as y };
